<template>
  <div class="organizationlist">
    <div class="container_wrap">
      <el-breadcrumb separator-class="el-icon-arrow-right" class="elbreadcrumb">
        <el-breadcrumb-item :to="{ path: '/indexpc' }">首页</el-breadcrumb-item>
        <el-breadcrumb-item>机构列表</el-breadcrumb-item>
      </el-breadcrumb>
      <div class="star_list">
        <div class="apply_now">
          <div class="apply_now_pic"></div>
          <div class="apply_now_btn" @click="applyJustNowFun()">立即申请</div>
        </div>
        <div
          class="star_list_item"
          v-for="(item, index) in ItemData"
          :key="index"
          @click="starItemClick(item)"
        >
          <div class="star_list_item_pic">
            <img
              :src="item.certificatepic[0].url"
              alt=""
              v-if="item.certificatepic && item.certificatepic.length"
            />
            <img src="#" alt="" v-else />
          </div>
          <div class="star_list_item_title">{{ item.name }}</div>
          <div class="star_list_item_decs">{{ item.content }}</div>
        </div>
      </div>
    </div>
    <DeBounce
      :fetch-fun="getNewsItemlist"
      :pagefetchflag="pagefetchflag"
    ></DeBounce>
  </div>
</template>
 <script>
import DeBounce from "@/components/DeBounce";
export default {
  name: "OrganizationList",
  data() {
    return {
      pagefetchflag: true,
      ItemData: [{ pics: {} }],
      listParams: {
        pageNo: 1,
        pageSize: 20,
        type: this.$route.query.type || 0,
      },
    };
  },
  mounted() {
    this.getNewsItemlist();
  },
  methods: {
    applyJustNowFun() {
      if (!this.$route.query.type) {
        this.$message({ type: "error", message: "参数type错误!" });
        return;
      }
      this.$router.push({
        path: "/danwei-apply-form",
        query: { type: this.$route.query.type },
      });
    },
    //更多 单位
    getNewsItemlist() {
      if (!this.$route.query.type) {
        this.$message({ type: "error", message: "参数type错误!" });
        return;
      }
      const that = this;
      that.$api.get(
        "/api/danwei/danweilist",
        this.listParams,
        (res) => {
          // this.$message.success("发送成功");
          // console.log("resres.....",res)
          // that.ItemData = res.data.list;

          if (this.listParams.pageNo == 1) {
            this.ItemData = res.data.list;
          } else {
            if (
              res.data.list &&
              res.data.list.length < this.listParams.pageSize
            ) {
              this.pagefetchflag = false;
              // this.$message.success("已加载全部！");
            }
            this.ItemData = this.ItemData.concat(res.data.list);
          }
          if (this.pagefetchflag) {
            this.listParams.pageNo += 1;
          }
        },
        (r) => {
          that.$message.error(r.msg);
        }
      );
    },
    //点击元素item  跳转
    starItemClick(val) {
      this.$router.push({
        path: "/cmsposition",
        query: { cmspositionId: val.id },
      });
    },
  },
  components: {
    DeBounce,
  },
};
</script>
 <style scoped lang="scss">
.organizationlist {
  width: 100%;
  background: #f4faff;
}
.container_wrap {
  background: #f4faff;
  width: 1240px;
  margin: 0 auto;
  min-height: 1285px;
  padding-bottom: 50px;
  box-sizing: border-box;
}
.elbreadcrumb {
  padding-top: 21px;
  margin: 0 0 0 23px;
}
.star_list {
  width: 100%;
  box-sizing: border-box;
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  margin-top: 41px;
  .apply_now {
    width: 380px;
    height: 403px;
    background: #75c3ff;
    box-shadow: 0px 4px 10px 0px rgba(0, 0, 0, 0.06);
    border-radius: 32px;
    margin-bottom: 49px;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    .apply_now_pic {
      width: 175px;
      height: 116px;
      background: url("~@/assets/images/listitem/icon-合作机构.png");
      margin-bottom: 50px;
    }
    .apply_now_btn {
      width: 224px;
      height: 56px;
      line-height: 56px;
      text-align: center;
      border-radius: 29px;
      background: #ebf6ff;
      font-size: 28px;
      font-family: "Euclid Flex Bold", Arial, "PingFang SC", Verdana,
        "\5FAE\8F6F\96C5\9ED1";
      font-weight: 500;
      color: #444444;
      cursor: default;
      &:hover {
        opacity: 0.9;
        cursor: pointer;
      }
    }
  }
  .star_list_item {
    display: flex;
    flex-direction: column;
    margin-bottom: 49px;
    cursor: default;
    width: 380px;
    height: 403px;
    background: #ffffff;
    box-shadow: 0px 4px 10px 0px rgba(0, 0, 0, 0.06);
    border-radius: 32px;
    overflow: hidden;
    transition: all 0.2s;
    &:hover {
      transform: scale(1.02);
      cursor: pointer;
    }
    &:nth-child(3n + 2) {
      margin-right: 50px;
      margin-left: 50px;
    }
    .star_list_item_pic {
      width: 380px;
      height: 251px;
      img {
        width: 100%;
        height: 100%;
        object-fit: cover;
      }
    }
    .star_list_item_title {
      max-height: 380px;
      font-size: 22px;
      font-family: "Euclid Flex Bold", Arial, "PingFang SC", Verdana,
        "\5FAE\8F6F\96C5\9ED1";
      font-weight: 500;
      color: #000000;
      line-height: 32px;
      margin: 24px 0 32px 12px;
    }
    .star_list_item_decs {
      width: 350px;
      font-size: 14px;

      font-weight: 400;
      color: #444444;
      line-height: 20px;
      margin-left: 12px;
      overflow: hidden;
      display: -webkit-box;
      -webkit-line-clamp: 2;
      -webkit-box-orient: vertical;
    }
  }
}
</style>


// WEBPACK FOOTER //
// OrganizationList.vue?bfdb8a84